<template>
  <div class="pc-root" :style="rootStyle">
    <header-nav></header-nav>
    <!-- 星空背景 -->
    <div ref="decor" class="pc-decor" aria-hidden="true"></div>
    <div class="pc-corner" aria-hidden="true">
      <svg class="corner-heart tl" viewBox="0 0 24 24" width="30" height="30">
        <path d="M12 21C6 16 2 12.5 2 8.5A4.5 4.5 0 0 1 6.5 4c1.8 0 3.5 1 5.5 3.2C14 5 15.7 4 17.5 4A4.5 4.5 0 0 1 22 8.5c0 4-4 7.5-10 12.5z" fill="#ffc1dd"/>
      </svg>
      <svg class="corner-heart br" viewBox="0 0 24 24" width="22" height="22">
        <path d="M12 21C6 16 2 12.5 2 8.5A4.5 4.5 0 0 1 6.5 4c1.8 0 3.5 1 5.5 3.2C14 5 15.7 4 17.5 4A4.5 4.5 0 0 1 22 8.5c0 4-4 7.5-10 12.5z" fill="#ffd6e7"/>
      </svg>
      <svg class="corner-bow tr" viewBox="0 0 40 32" width="38" height="30">
        <path d="M20 16 C 10 2, 2 4, 5 12 C 8 20, 17 20, 20 16 Z" fill="#ffd6e7"/>
        <path d="M20 16 C 30 2, 38 4, 35 12 C 32 20, 23 20, 20 16 Z" fill="#ffd6e7"/>
        <circle cx="20" cy="15.5" r="4" fill="#fff" stroke="#ff9db8" stroke-width="1.5"/>
      </svg>
      <svg class="corner-bow bl" viewBox="0 0 40 32" width="28" height="22">
        <path d="M20 16 C 10 2, 2 4, 5 12 C 8 20, 17 20, 20 16 Z" fill="#ff9dc6"/>
        <path d="M20 16 C 30 2, 38 4, 35 12 C 32 20, 23 20, 20 16 Z" fill="#ff9dc6"/>
        <circle cx="20" cy="15.5" r="4" fill="#fff" stroke="#ff6fa5" stroke-width="1.5"/>
      </svg>
    </div>

    <!-- ===== 全站左右布局 ===== -->
    <div class="treasure-layout">
      <!-- 左侧固定功能区 -->
      <aside class="treasure-side">
        <!-- 品牌卡 -->
        <div class="side-card side-brand">
          <div class="side-badge">✦ 洛丽寻宝 ✦</div>
          <h1 class="side-name">星裙·补给</h1>
          <p class="side-slogan">寻宝 · 传说等你来拿</p>
        </div>

        <!-- 账号信息卡 -->
        <div class="side-card side-account">
          <div class="side-card-title">🌟 账号信息</div>
          <template v-if="loggedIn">
            <div class="account-row">
              <span class="account-label">账号</span>
              <span class="account-value">{{ userName || curNo }}</span>
            </div>
            <div class="account-row">
              <span class="account-label">星裙币</span>
              <span class="account-value account-coins">{{ coins }}</span>
            </div>
            <div class="account-row">
              <span class="account-label">碎片</span>
              <span class="account-value account-frags">{{ fragments }}</span>
            </div>
            <div class="account-row">
              <span class="account-label">累计抽奖</span>
              <span class="account-value">{{ totalPulls }} 次</span>
            </div>
          </template>
          <div v-else class="side-login">登录后开启补给、查看背包～</div>
        </div>

        <!-- 功能菜单 -->
        <div class="side-card side-menu">
          <div class="side-card-title">🧭 寻宝功能</div>
          <div class="menu-item" :class="{ active: view === 'lottery' }" @click="view = 'lottery'">
            <i class="el-icon-present"></i><span>寻宝抽奖</span>
          </div>
          <div class="menu-item" :class="{ active: view === 'pool' }" @click="goPool">
            <i class="el-icon-trophy"></i><span>奖池预览</span>
          </div>
          <div class="menu-item" :class="{ active: view === 'bag' }" @click="goBag">
            <i class="el-icon-goods"></i><span>我的背包</span>
          </div>
          <div class="menu-item" @click="exchangeModal = true">
            <i class="el-icon-magic-stick"></i><span>碎片商城</span>
          </div>
        </div>

        <!-- 底部：音效开关 -->
        <div class="side-foot">
          <button class="side-sound" :class="{ off: muted }" :title="muted ? '开启音效' : '关闭音效'" @click="toggleMute">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
              <path d="M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z"/>
            </svg>
            <span>{{ muted ? '音效已关' : '音效已开' }}</span>
          </button>
        </div>
      </aside>

      <!-- 右侧内容区（内部滚动） -->
      <main class="treasure-main">
        <!-- ===== 抽奖视图 ===== -->
        <section v-show="view === 'lottery'" class="lottery-view">
          <div class="stage" :class="{ 'stage-shake': shake }" @click="skipAllReveal">
            <span class="stage-bow" aria-hidden="true"></span>
            <div v-if="!revealCards.length" class="stage-idle">
              <div class="idle-ring"></div>
                            <p v-if="poolEmpty" class="idle-text">这里还没有发现宝藏<br>等待奖池上新</p>
              <p v-else class="idle-text">消耗星裙币开启补给<br>传说等你来拿</p>
            </div>
            <div v-else class="cards-grid" :class="{ 'is-ten': revealCards.length > 1 }">
              <div v-for="(c, i) in revealCards" :key="pullSeq + '-' + i" class="card-slot"
                   :style="{ animationDelay: (i * 0.045) + 's' }">
                <div class="card" :class="['q-' + c.item.q, { revealed: c.revealed }]">
                  <div class="card-inner">
                    <div class="card-face card-back">
                      <div class="back-pattern"></div>
                      <span class="back-text">{{ (currentPool || {}).name || '星裙补给' }}</span>
                    </div>
                    <div class="card-face card-front">
                      <img v-if="c.item.img" class="card-img" :src="c.item.img" :alt="c.item.name">
                      <div v-else class="card-img card-img-icon">{{ itemEmoji(c.item) }}</div>
                      <div v-if="c.revealed && c.item.q === 'blue'" class="card-shine"></div>
                      <div v-if="c.revealed && (c.item.q === 'red' || c.item.q === 'pink')" class="card-sparks">
                        <i v-for="n in 6" :key="n" :style="sparkStyle(n)"></i>
                      </div>
                      <div class="card-type">{{ c.item.type }}</div>
                      <div class="card-name">{{ c.item.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button v-if="pulling" class="skip-btn" @click.stop="skipAllReveal">跳过动画</button>
          </div>

          <div class="lottery-dock">
          <div class="pull-bar">
            <button class="btn-pull btn-single" :disabled="pulling || !loggedIn || poolEmpty" @click="doPull(1)">
              <span class="btn-main">单抽</span>
              <span class="btn-cost">10 星裙币</span>
            </button>
            <button class="btn-pull btn-ten" :disabled="pulling || !loggedIn || poolEmpty" @click="doPull(10)">
              <span class="btn-main">十连抽</span>
              <span class="btn-cost">95 星裙币</span>
            </button>
          </div>

          <div class="milestone">
            <div class="milestone-head">
              <span class="ms-label">补给里程碑</span>
              <span class="ms-total">本奖池抽奖 {{ poolPullCount }} / 200 次</span>
            </div>
            <div class="ms-track">
              <div class="ms-fill" :style="{ width: msFillWidth }"></div>
              <div v-for="m in milestones" :key="m.n" class="ms-node"
                   :class="{ done: msClaimed(m.n), ready: canClaim(m), locked: !canClaim(m) && !msClaimed(m.n) }"
                   :style="{ left: msPos(m.n) }" @click="openMilestone(m)">
                <span class="ms-dot">{{ msClaimed(m.n) ? '已' : (canClaim(m) ? '领' : m.n) }}</span>
                <span class="ms-tip">{{ m.n }} 次</span>
              </div>
            </div>
          </div>
          </div>
        </section>

        <!-- ===== 奖池视图 ===== -->
        <section v-show="view === 'pool'" class="pool-view">
          <aside class="pool-side">
            <div class="pool-side-head">
              <div class="pool-side-title">奖池预览</div>
            </div>
            <div v-if="!poolEmpty" class="pool-list">
              <div v-for="q in qualityList" :key="q.key" class="pool-group">
                <div class="pool-group-title">
                  <span class="qdot" :style="{ background: q.color, boxShadow: '0 0 8px ' + q.color }"></span>
                  <span>{{ q.name }}</span>
                  <span class="pool-group-rate">概率 {{ probText(q.key) }}</span>
                </div>
                <div v-for="item in poolOf(q.key)" :key="item.id" class="pool-item"
                     :class="{ active: selectedItem && selectedItem.id === item.id }" @click="selectItem(item)">
                  <div class="pool-item-thumb">
                    <img v-if="item.img" class="pool-item-img" :src="item.img" :alt="item.name">
                    <div v-else class="pool-item-img pool-item-icon">{{ itemEmoji(item) }}</div>
                    <span v-if="bag[item.id]" class="owned-badge">已获得</span>
                  </div>
                  <div class="pool-item-info">
                    <div class="pool-item-name" :style="{ color: q.color }">{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="pool-empty">这里还没有发现宝藏，等待奖池上新</div>
          </aside>
          <section v-if="selectedItem" class="pool-preview">
            <div class="preview-card" :class="'q-' + selectedItem.q">
              <div class="preview-imgwrap">
                <img v-if="selectedItem.img" :src="selectedItem.img" :alt="selectedItem.name">
                <div v-else class="preview-icon">{{ itemEmoji(selectedItem) }}</div>
                <span v-if="bag[selectedItem.id]" class="owned-badge big">已获得</span>
              </div>

            </div>
            <div class="preview-info">
              <div class="preview-q" :style="{ color: qColor(selectedItem.q) }">{{ qName(selectedItem.q) }}</div>
              <div class="preview-name">{{ selectedItem.name }}</div>
              <div class="preview-type">{{ selectedItem.type }}</div>
              <p class="preview-desc">{{ selectedItem.desc }}</p>
              <div class="preview-meta">
                <span class="meta-chip">出售价 <b class="coin-text">{{ priceOf(selectedItem) }}</b> 星裙币</span>
                <span class="meta-chip">碎片兑换 <b class="frag-text">{{ fragCostOf(selectedItem) }}</b> 碎片</span>
              </div>
              <div class="preview-actions">
                <span class="preview-frags">当前碎片 <b class="frag-text">{{ fragments }}</b></span>
                <button class="preview-exchange" :disabled="fragments < fragCostOf(selectedItem)"
                        @click="exchangeItem(selectedItem)">碎片兑换</button>
              </div>
            </div>


          </section>
          <section v-else class="pool-preview pool-preview-empty">
            <p>{{ poolEmpty ? '这里还没有发现宝藏，等待奖池上新' : '从左侧列表选择一件道具查看详情' }}</p>
          </section>
        </section>

        <!-- ===== 背包视图 ===== -->
        <section v-show="view === 'bag'" class="bag-view">
          <div class="bag-head">
            <h2>我的背包</h2>
          </div>
          <div v-if="!bagList.length" class="bag-empty">
            <p class="bag-empty-main">背包空空如也</p>
            <p class="bag-empty-sub">去抽卡，把传说带回家</p>
            <button class="nav-btn nav-exchange" @click="view = 'lottery'">去抽卡</button>
          </div>
          <div v-else class="bag-grid">
            <div v-for="g in bagList" :key="g.item.id" class="bag-card" :class="'q-' + g.item.q">
              <div class="bag-card-top">
                <img v-if="g.item.img" :src="g.item.img" :alt="g.item.name">
                <div v-else class="bag-card-icon">{{ itemEmoji(g.item) }}</div>
                <span class="bag-count">×{{ g.count }}</span>
              </div>
              <div class="bag-card-info">
                <div class="bag-card-name">{{ g.item.name }}</div>
                <div v-if="g.item.type === '碎片'" class="bag-card-frags">碎片数量 {{ fragAmountOf(g.item) }}</div>
                <div v-else class="bag-card-price">出售价 : {{ priceOf(g.item) }}</div>
              </div>
              <div v-if="g.item.type !== '碎片'" class="bag-card-actions">
                <button class="sell-btn sell-direct" @click="sellItem(g.item, 'direct')">直接出售</button>
                <button class="sell-btn sell-gamble" @click="sellItem(g.item, 'gamble')">概率出售</button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <!-- 右侧奖池切换栏（竖向容器，数量由后台「奖池管理」增删改） -->
      <aside class="pool-switcher">
        <div class="switcher-title">奖池</div>
        <div class="switcher-icons">
          <button v-for="p in pools" :key="p.poolKey"
                  class="switcher-icon"
                  :class="{ active: currentPool && currentPool.poolKey === p.poolKey }"
                  :title="currentPool && currentPool.poolKey === p.poolKey ? p.name + ' · 当前奖池' : p.name"
                  @click="switchPool(p.poolKey)">
            <span class="switcher-ico">{{ p.icon }}</span>
            <span class="switcher-label">{{ p.name }}</span>
          </button>
        </div>
      </aside>
    </div>

    <!-- 抽卡结果弹窗 -->
    <transition name="modal">
      <div v-if="resultModal" class="modal-mask" @click.self="resultModal = false">
        <div class="modal-box result-box">
          <h3 class="modal-title">补给结果</h3>
          <div class="result-list">
            <div v-for="(g, i) in resultGroups" :key="i" class="result-row" :class="'q-' + g.q">
              <img v-if="g.img" :src="g.img" :alt="g.name">
              <div v-else class="card-img-icon" style="width: 52px; height: 52px; border-radius: 10px; font-size: 26px;">{{ itemEmoji(g) }}</div>
              <div class="result-info">
                <span class="result-name">{{ g.name }}</span>
                <span class="result-q" :style="{ color: qColor(g.q) }">{{ qName(g.q) }}</span>
              </div>
              <span class="result-count">×{{ g.count }}</span>
            </div>
          </div>
          <button class="modal-ok" @click="resultModal = false">收下</button>
        </div>
      </div>
    </transition>

    <!-- 里程碑领取弹窗 -->
    <transition name="modal">
      <div v-if="milestoneModal && milestoneTarget" class="modal-mask" @click.self="milestoneModal = false">
        <div class="modal-box ms-modal">
          <h3 class="modal-title">里程碑奖励</h3>
          <p class="ms-modal-sub">本奖池累计抽奖达到 {{ milestoneTarget.n }} 次，二选一领取：</p>
          <div class="ms-choices">
            <button class="ms-choice" @click="claimMilestone('frags')">
              <span class="ms-choice-ico gem frag-gem"></span>
              <span class="ms-choice-main">碎片 × {{ milestoneTarget.frags }}</span>
              <span class="ms-choice-sub">可用于碎片商城兑换道具</span>
            </button>
            <button class="ms-choice" @click="claimMilestone('item')">
              <span class="ms-choice-ico gem" :style="{ background: qColor(milestoneTarget.q), boxShadow: '0 0 12px ' + qColor(milestoneTarget.q) }"></span>
              <span class="ms-choice-main">随机{{ qName(milestoneTarget.q) }}物品</span>
              <span class="ms-choice-sub">从奖池随机获得一件</span>
            </button>
          </div>
          <button class="modal-ok ghost" @click="milestoneModal = false">稍后选择</button>
        </div>
      </div>
    </transition>

    <!-- 碎片商城弹窗 -->
    <transition name="modal">
      <div v-if="exchangeModal" class="modal-mask" @click.self="exchangeModal = false">
        <div class="modal-box shop-box">
          <h3 class="modal-title">碎片商城</h3>
          <p class="shop-sub">当前碎片 <b class="frag-num-inline">{{ fragments }}</b> · 选择道具直接兑换指定装扮</p>
          <div class="shop-list">
            <div v-for="item in shopItems" :key="item.id" class="shop-row shop-item-row">
              <span class="qdot" :style="{ background: qColor(item.q), boxShadow: '0 0 8px ' + qColor(item.q) }"></span>
              <img v-if="item.img" class="shop-item-img" :src="item.img" :alt="item.name">
              <div v-else class="shop-item-ico">{{ itemEmoji(item) }}</div>
              <span class="shop-q-name" :style="{ color: qColor(item.q) }">{{ item.name }}</span>
              <span class="shop-cost">{{ fragCostOf(item) }} 碎片</span>
              <button class="shop-btn" :disabled="fragments < fragCostOf(item)" @click="exchangeItem(item)">兑换</button>
            </div>
          </div>
          <button class="modal-ok ghost" @click="exchangeModal = false">关闭</button>
        </div>
      </div>
    </transition>

    <!-- 传说降临 -->
    <transition name="fade">
      <div v-if="legendOverlay" class="legend-overlay">
        <div class="legend-rays"></div>
        <div class="legend-core">
          <div class="legend-q">传说降临</div>
          <div class="legend-name">{{ legendItem ? legendItem.name : '' }}</div>
          <div class="legend-sub">RED LEGENDARY DROP</div>
        </div>
      </div>
    </transition>

    <!-- 提示 -->
    <transition-group name="toast" tag="div" class="toast-wrap">
      <div v-for="t in toasts" :key="t.id" class="toast" :class="t.type">{{ t.msg }}</div>
    </transition-group>
  </div>

</template>

<script>
// 本地立绘动态加载：各奖池目录（star-skirt / fairy-tales 等）图片自动打包
// （后台图片字段填文件名时按此解析，填完整URL则直接使用）
import HeaderNav from "@/components/HeaderNav.vue";
import bus from "../../utils/bus";

const LOCAL_IMGS = {}
function indexImgs(ctx) {
  ctx.keys().forEach(function (k) {
    const name = k.split('/').pop().replace(/\.[a-z0-9]+$/i, '').toLowerCase()
    if (!LOCAL_IMGS[name]) LOCAL_IMGS[name] = ctx(k)
  })
}
// 递归扫描洛丽寻宝全部子目录：后台新增奖池后，只需在 LolitaTreasure 下新建对应目录并放入图片即可被识别，无需再改代码
indexImgs(require.context('./', true, /\.(jpg|jpeg|png|gif)$/))

// 后台奖池接口不可用时的兜底奖池（与数据库种子一致）
const DEFAULT_POOLS = [
  { poolKey: 'star_skirt', name: '星裙补给', icon: '💫', themeColor: '#F0619C', themeDeep: '#E0539C' },
  { poolKey: 'fairy_tales', name: '星月童话', icon: '🌙', themeColor: '#6F8BFF', themeDeep: '#4A5BD8' }
]

function hexToRgb(hex) {
  if (!hex) return null
  const m = /^#?([0-9a-fA-F]{6})$/.exec(String(hex).trim())
  if (!m) return null
  const n = parseInt(m[1], 16)
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}
function mixBlack(hex, ratio) {
  const c = hexToRgb(hex)
  if (!c) return hex
  const r = Math.round(c.r * (1 - ratio))
  const g = Math.round(c.g * (1 - ratio))
  const b = Math.round(c.b * (1 - ratio))
  return '#' + [r, g, b].map(function (v) { return ('0' + v.toString(16)).slice(-2) }).join('')
}
function mixWhite(hex, ratio) {
  const c = hexToRgb(hex)
  if (!c) return hex
  const r = Math.round(c.r + (255 - c.r) * ratio)
  const g = Math.round(c.g + (255 - c.g) * ratio)
  const b = Math.round(c.b + (255 - c.b) * ratio)
  return '#' + [r, g, b].map(function (v) { return ('0' + v.toString(16)).slice(-2) }).join('')
}

const QUALITY_ORDER = ['red', 'pink', 'blue', 'purple', 'green']
const QUALITY_RANK = { red: 0, pink: 1, blue: 2, purple: 3, green: 4 }

// 品质配置：概率(累进) / 出售价 / 碎片兑换价
const QUALITIES = {
  red: { key: 'red', name: '传说', color: '#ff4d6d', probText: '0.2%', price: 888, fragCost: 800 },
  pink: { key: 'pink', name: '史诗', color: '#ff7fb9', probText: '5%', price: 88, fragCost: 150 },
  blue: { key: 'blue', name: '稀有', color: '#7fc9ff', probText: '38%', price: 18, fragCost: 60 },
  purple: { key: 'purple', name: '精良', color: '#c39aff', probText: '35%', price: 8, fragCost: 30 },
  green: { key: 'green', name: '普通', color: '#7fdc9c', probText: '21.8%', price: 2, fragCost: 15 }
}
// 货币为普通道具：抽到进入背包，不再直接入账；碎片抽到进入背包并同时累加碎片余额
function settleAmount(it) {
  if (!it) return 0
  if (it.amount != null && it.amount > 0) return it.amount
  if (it.id === 'u_frag50') return 50
  if (it.id === 'u_frag100') return 100
  if (it.id === 'u_coin50') return 50
  return 0
}

// 奖池 28 件道具（可由后台「宝藏管理」下发覆盖；接口不可用时沿用内置奖池）
let POOL = [
  { id: 'r1', q: 'red', name: '星陨战神', type: '套装', img: 'r1_jixingzhanjia.jpg', desc: '传说级套装。红金机甲注入陨星之力，行走战场自带星辉残影，出场即是全场焦点。' },
  { id: 'r2', q: 'red', name: '龙魂裁决', type: '狙击枪', img: 'r2_longhunbarete.jpg', desc: '传说级枪械。沉睡龙魂铸成的重型狙击，命中瞬间龙息炸裂，是绝境翻盘的信仰之枪。' },
  { id: 'r3', q: 'red', name: '苍穹之翼', type: '飞行器', img: 'r3_cangqiongzhiyi.jpg', desc: '传说级载具。双翼划破长空，金色流光缠绕机身，全场玩家都将仰望你的航线。' },
  { id: 'r4', q: 'red', name: '星辉圣冠', type: '头盔', img: 'r4_xinghuishengguan.jpg', desc: '传说级头盔。璀璨星辉凝结的战术王冠，危机时刻依然闪耀不灭星光。' },
  { id: 'r5', q: 'red', name: '赤焰凤凰', type: '降落伞', img: 'r5_chiyanfenghuang.jpg', desc: '传说级降落伞。凤凰展翅的赤金伞面，开伞瞬间烈焰环绕，落地如凤凰涅槃。' },
  { id: 'p1', q: 'pink', name: '甜心小恶魔', type: '套装', img: 'p1_tianxinxiaoemo.jpg', desc: '史诗级套装。甜美外表下藏着狡黠，蝴蝶结与恶魔角的设计俏皮又吸睛。' },
  { id: 'p2', q: 'pink', name: '梦幻泡泡', type: '冲锋枪', img: 'p2_menghuanpaopao.jpg', desc: '史诗级枪械。枪身流淌粉彩泡泡，射击时飘散彩虹气泡，可爱与火力并存。' },
  { id: 'p3', q: 'pink', name: '蜜桃物语', type: '背包', img: 'p3_mitaowuyu.jpg', desc: '史诗级背包。软萌蜜桃造型，随身携带甜度满分的战场补给。' },
  { id: 'p4', q: 'pink', name: '粉晶蝶梦', type: '头盔', img: 'p4_fenjingdiemeng.jpg', desc: '史诗级头盔。粉晶蝶翼点缀的护盔，少女心与安全感一次拉满。' },
  { id: 'p5', q: 'pink', name: '彩虹云朵', type: '降落伞', img: 'p5_caihongyunduo.jpg', desc: '史诗级降落伞。踩着彩虹云朵缓缓落地，做全场最温柔的风景线。' },
  { id: 'b1', q: 'blue', name: '极地冰锋', type: '套装', img: 'b1_jidibingfeng.jpg', desc: '稀有级套装。极地寒冰锻造的作战服，表面浮动着凛冽的冰霜纹路。' },
  { id: 'b2', q: 'blue', name: '寒霜AKM', type: '步枪', img: 'b2_hanshuangAKM.jpg', desc: '稀有级枪械。枪身覆满冰晶，开火时枪口凝出霜雾，冷酷而致命。' },
  { id: 'b3', q: 'blue', name: '冰川之息', type: '背包', img: 'b3_bingchuanzhixi.jpg', desc: '稀有级背包。冰川蓝调与雪山纹路，承载远征极地的勇气。' },
  { id: 'b4', q: 'blue', name: '冰晶幻盔', type: '头盔', img: 'b4_bingjinghuankui.jpg', desc: '稀有级头盔。棱形冰晶结构，折射出战场的每一道冷光。' },
  { id: 'b5', q: 'blue', name: '蓝月之翼', type: '降落伞', img: 'b5_lanyuezhiyi.jpg', desc: '稀有级降落伞。月光洒落的海蓝伞面，夜空滑翔如坠入深蓝梦境。' },
  { id: 'b6', q: 'blue', name: '蓝鲸巡航', type: '载具', img: 'b6_lanjingxunhang.jpg', desc: '稀有级载具。深海蓝鲸涂装的越野车，沉稳可靠，碾过每一片战区。' },
  { id: 'u1', q: 'purple', name: '紫罗兰魅影', type: '套装', img: 'u1_ziluolanmeiying.jpg', desc: '精良级套装。暮色紫罗兰配色，潜行于夜色，隐秘而优雅。' },
  { id: 'u2', q: 'purple', name: '紫晶M416', type: '步枪', img: 'u2_zijingM416.jpg', desc: '精良级枪械。紫晶点缀的枪身，稳定输出，颜值同样在线。' },
  { id: 'u3', q: 'purple', name: '迷雾紫蝶', type: '背包', img: 'u3_miwuzidie.jpg', desc: '精良级背包。紫蝶振翅的雾面质感，低调的战场美学。' },
  { id: 'u4', q: 'purple', name: '神秘紫冠', type: '头盔', img: 'u4_shenmiziguan.jpg', desc: '精良级头盔。神秘主义纹路，戴上它你就是夜色中的传说。' },
  { id: 'u5', q: 'purple', name: '暮色星尘', type: '降落伞', img: 'u5_musexingchen.jpg', desc: '精良级降落伞。紫霞与星尘交织的伞面，黄昏时分开伞最美。' },
  { id: 'u6', q: 'purple', name: '暗紫战靴', type: '鞋', img: 'u6_anziwuxue.jpg', desc: '精良级鞋类。轻便耐磨的暗紫战靴，每一步都踏出速度感。' },
  { id: 'u_frag50', q: 'purple', name: '碎片 ×50', type: '碎片', amount: 50, img: null, desc: '碎片礼包，抽到进入背包并累加碎片余额，可在背包查看碎片数量。' },
  { id: 'u_frag100', q: 'purple', name: '碎片 ×100', type: '碎片', amount: 100, img: null, desc: '碎片礼包，抽到进入背包并累加碎片余额，可在背包查看碎片数量。' },
  { id: 'u_coin50', q: 'purple', name: '星裙币 ×50', type: '货币', amount: 50, img: null, desc: '星裙币礼包，抽到进入背包，可像普通道具一样持有与出售。' },
  { id: 'g1', q: 'green', name: '丛林迷彩', type: '套装', img: 'g1_conglinmimi.jpg', desc: '普通级套装。与丛林融为一体的经典迷彩，老兵的可靠选择。' },
  { id: 'g2', q: 'green', name: '森林S686', type: '霰弹枪', img: 'g2_senlinS686.jpg', desc: '普通级枪械。木纹与绿漆质感，近战爆发力十足。' },
  { id: 'g3', q: 'green', name: '绿野仙踪', type: '背包', img: 'g3_lvyexianzong.jpg', desc: '普通级背包。清新绿野配色，容量与颜值兼顾。' },
  { id: 'g4', q: 'green', name: '草编伪装盔', type: '头盔', img: 'g4_caobianweizhuangkui.jpg', desc: '普通级头盔。草编伪装结构，伏地时几乎难以察觉。' },
  { id: 'g5', q: 'green', name: '林间清风', type: '降落伞', img: 'g5_linjianqingfeng.jpg', desc: '普通级降落伞。翠绿伞面掠过林梢，稳稳落进安全区。' },
  { id: 'g6', q: 'green', name: '迷彩战靴', type: '鞋', img: 'g6_micaiwuxue.jpg', desc: '普通级鞋类。耐磨防滑，陪你跑遍整张地图。' }
]

let ITEM_MAP = {}
POOL.forEach(function (it) { ITEM_MAP[it.id] = it })

// 里程碑：次数 -> 碎片数 / 可选随机物品品质
const MILESTONES = [
  { n: 10, frags: 10, q: 'green' },
  { n: 30, frags: 30, q: 'purple' },
  { n: 60, frags: 60, q: 'blue' },
  { n: 100, frags: 100, q: 'pink' },
  { n: 140, frags: 140, q: 'pink' },
  { n: 200, frags: 200, q: 'red' }
]

export default {
  name: 'LolitaTreasure',
  components: {HeaderNav},
  data() {
    return {
      coins: 0,
      curNo: '',
      userName: '',
      loggedIn: false,
      totalPulls: 0,
      poolPulls: {},
      poolClaimed: {},
      poolItems: {}, // 各奖池道具列表缓存（响应式，切换/加载后驱动列表刷新）
      fragments: 0,
      bag: {},
      claimed: {},
      view: 'lottery',
      pulling: false,
      shake: false,
      pullSeq: 0,
      revealCards: [],
      lastGains: [],
      resultModal: false,
      milestoneModal: false,
      milestoneTarget: null,
      exchangeModal: false,
      legendOverlay: false,
      legendItem: null,
      selectedItem: null,
      toasts: [],
      muted: false,
      pools: [],
      currentPool: null
    }
  },
  computed: {
    rootStyle() {
      const t = this.currentPool || DEFAULT_POOLS[0]
      // 独立配色：按钮/背景/文字分别取值，缺失时回退基础主题色（themeColor/themeDeep）
      const btnD = hexToRgb(t.btnDeep || t.themeDeep) || { r: 224, g: 83, b: 156 }
      const bgC = hexToRgb(t.bgColor || t.themeColor) || { r: 253, g: 231, b: 240 }
      const btnDeepHex = t.btnDeep || t.themeDeep || '#E0539C'
      const bgGradHex = t.bgColor || t.themeColor || '#F0619C'
      const bgDeepHex = t.bgDeep || t.themeDeep || '#E0539C'
      const cardHex = t.cardColor || t.themeDeep || '#FF5FA8'
      const cardC = hexToRgb(cardHex) || { r: 255, g: 95, b: 168 }
      const bg = [
        'radial-gradient(1100px 480px at 8% -8%, rgba(255,255,255,0.95), transparent 55%)',
        'radial-gradient(900px 460px at 95% -6%, rgba(' + bgC.r + ',' + bgC.g + ',' + bgC.b + ',0.30), transparent 58%)',
        'radial-gradient(700px 380px at 50% 116%, rgba(' + bgC.r + ',' + bgC.g + ',' + bgC.b + ',0.28), transparent 62%)',
        'radial-gradient(520px 320px at 50% 30%, rgba(255,255,255,0.55), transparent 70%)',
        'repeating-radial-gradient(circle at 50% 0%, rgba(255,255,255,0.5) 0 1px, transparent 1px 90px)',
        'linear-gradient(180deg, ' + mixWhite(bgGradHex, 0.86) + ' 0%, ' + mixWhite(bgGradHex, 0.75) + ' 40%, ' + mixWhite(bgDeepHex, 0.6) + ' 78%, ' + mixWhite(bgDeepHex, 0.45) + ' 100%)'
      ].join(', ')
      return {
        '--theme-color': t.btnColor || t.themeColor,
        '--theme-deep': t.btnDeep || t.themeDeep,
        '--theme-deep2': mixBlack(btnDeepHex, 0.3),
        '--theme-glow': 'rgba(' + btnD.r + ',' + btnD.g + ',' + btnD.b + ',0.55)',
        '--text-color': t.textColor || t.themeDeep || '#E0539C',
        '--card-bg': 'linear-gradient(160deg, ' + mixWhite(cardHex, 0.93) + ', ' + mixWhite(cardHex, 0.82) + ' 55%, ' + mixWhite(cardHex, 0.68) + ')',
        '--card-dot': 'rgba(' + cardC.r + ',' + cardC.g + ',' + cardC.b + ',0.22)',
        '--card-border': mixWhite(cardHex, 0.45),
        '--card-dash': 'rgba(' + cardC.r + ',' + cardC.g + ',' + cardC.b + ',0.5)',
        '--card-pat': 'rgba(' + cardC.r + ',' + cardC.g + ',' + cardC.b + ',0.2)',
        '--bg-grad': bg
      }
    },
    shopItems() {
      return this.currentItems.filter(function (it) {
        return it.type !== '货币' && it.type !== '碎片'
      }).slice().sort(function (a, b) {
        return QUALITY_RANK[a.q] - QUALITY_RANK[b.q] || a.id.localeCompare(b.id)
      })
    },
    qualityList() {
      return QUALITY_ORDER.map(function (k) { return QUALITIES[k] })
    },
    milestones() {
      return MILESTONES
    },
    currentPoolKey() {
      return (this.currentPool && this.currentPool.poolKey) || 'star_skirt'
    },
    poolPullCount() {
      return this.poolPulls[this.currentPoolKey] || 0
    },
    currentItems() {
      return this.poolItems[this.currentPoolKey] || []
    },
    poolEmpty() {
      return this.currentItems.length === 0
    },
    msFillWidth() {
      return Math.min((this.poolPullCount / 200) * 100, 100) + '%'
    },
    bagList() {
      const self = this
      const curMap = {}
      this.currentItems.forEach(function (it) { curMap[it.id] = it })
      return Object.keys(this.bag).map(function (id) {
        return { item: curMap[id], count: self.bag[id] }
      }).filter(function (a) { return a.item })
      .sort(function (a, b) {
        return QUALITY_RANK[a.item.q] - QUALITY_RANK[b.item.q] || a.item.id.localeCompare(b.item.id)
      })
    },
    resultGroups() {
      const map = {}
      this.lastGains.forEach(function (it) {
        if (!map[it.id]) {
          map[it.id] = { id: it.id, name: it.name, q: it.q, type: it.type, img: it.img, count: 0 }
        }
        map[it.id].count += 1
      })
      return Object.keys(map).map(function (id) { return map[id] })
        .sort(function (a, b) { return QUALITY_RANK[a.q] - QUALITY_RANK[b.q] })
    }
  },
  methods: {
    toast(msg, type) {
      const id = Date.now() + Math.random()
      this.toasts.push({ id: id, msg: msg, type: type || '' })
      const self = this
      setTimeout(function () {
        self.toasts = self.toasts.filter(function (t) { return t.id !== id })
      }, 2600)
    },
    syncCoinToSession() {
      try {
        const cu = JSON.parse(sessionStorage.getItem('CurUser') || '{}')
        cu.coin = this.coins
        sessionStorage.setItem('CurUser', JSON.stringify(cu))
      } catch (e) { /* ignore */ }
    },
    refreshCoin() {
      const self = this
      this.$axios.get(this.$httpUrl + '/user/findByNo?no=' + encodeURIComponent(this.curNo))
        .then(r => r.data).then(res => {
          if (res.code === 200 && res.data && res.data[0]) {
            self.coins = res.data[0].coin || 0
            self.syncCoinToSession()
          }
        })
    },
    loadInventory() {
      const self = this
      this.$axios.get(this.$httpUrl + '/user/inventory?no=' + encodeURIComponent(this.curNo))
        .then(function (r) { return r.data })
        .then(function (res) {
          if (res.code === 200 && res.data) {
            self.fragments = res.data.fragments || 0
            self.totalPulls = res.data.totalPulls || 0
            self.poolPulls = res.data.poolPulls || {}
            self.poolClaimed = res.data.poolClaimed || {}
            const claimedArr = res.data.claimed || []
            const claimedObj = {}
            claimedArr.forEach(function (n) { claimedObj[n] = true })
            self.claimed = claimedObj
            self.bag = res.data.bag || {}
          }
        })
        .catch(function () { /* ignore */ })
    },
    saveInventory() {
      if (!this.curNo) return
      const self = this
      const bagOut = {}
      Object.keys(this.bag || {}).forEach(function (k) {
        if (self.bag[k] > 0) bagOut[k] = self.bag[k]
      })
      const claimedArr = Object.keys(this.claimed || {}).filter(function (k) { return self.claimed[k] })
      this.$axios.post(this.$httpUrl + '/user/saveInventory', {
        no: this.curNo,
        poolPulls: this.poolPulls || {},
        poolClaimed: this.poolClaimed || {},
        fragments: this.fragments,
        totalPulls: this.totalPulls,
        claimed: claimedArr,
        bag: bagOut
      }).catch(function () { /* ignore */ })
    },
    onUserChanged() {
      try {
        const cu = JSON.parse(sessionStorage.getItem('CurUser') || '{}')
        this.curNo = cu.no || ''
        this.userName = cu.name || ''
        this.coins = cu.coin || 0
      } catch (e) {
        this.curNo = ''
        this.userName = ''
        this.coins = 0
      }
      this.loggedIn = !!this.curNo
      if (this.loggedIn) {
        this.refreshCoin()
        this.loadInventory()
      } else {
        this.fragments = 0
        this.bag = {}
        this.totalPulls = 0
        this.poolPulls = {}
        this.poolClaimed = {}
        this.claimed = {}
      }
    },
    toggleMute() {
      this.muted = !this.muted
      try {
        localStorage.setItem('pc-muted', this.muted ? '1' : '0')
      } catch (e) { /* 忽略 */ }
      if (!this.muted) this.playSound('click')
    },
    rollQuality() {
      const r = Math.random() * 100
      if (r < 0.2) return 'red'
      if (r < 5.2) return 'pink'
      if (r < 43.2) return 'blue'
      if (r < 78.2) return 'purple'
      return 'green'
    },
    pickItem(q) {
      const pool = POOL.filter(function (it) { return it.q === q })
      return pool[Math.floor(Math.random() * pool.length)]
    },
    doPull(n) {
      if (this.pulling) return
      if (!POOL.length) {
        this.toast('该奖池还没有宝藏，等待上新', 'bad')
        return
      }
      if (!this.loggedIn || !this.curNo) {
        this.toast('请先登录后再抽卡', 'bad')
        return
      }
      const cost = n === 10 ? 95 : 10
      if (this.coins < cost) {
        this.playSound('click')
        this.toast('星裙币不足，当前余额 ' + this.coins, 'bad')
        return
      }
      this.pulling = true
      const self = this
      this.$axios.post(this.$httpUrl + '/user/updateCoin', { no: this.curNo, delta: -cost })
        .then(function (r) { return r.data })
        .then(function (res) {
          if (res.code !== 200) {
            self.pulling = false
            self.toast(res.msg || '扣币失败', 'bad')
            return
          }
          self.coins = res.data.coin
          self.syncCoinToSession()
          const gains = []
          for (let i = 0; i < n; i++) {
            const item = self.pickItem(self.rollQuality())
            gains.push(item)
            if (item.type === '碎片' || item.id === 'u_frag50' || item.id === 'u_frag100') {
              self.fragments += settleAmount(item)
            }
            self.$set(self.bag, item.id, (self.bag[item.id] || 0) + 1)
          }
          self.totalPulls += n
          self.$set(self.poolPulls, self.currentPoolKey, (self.poolPulls[self.currentPoolKey] || 0) + n)
          self.pullSeq += 1
          self.revealCards = gains.map(function (item) { return { item: item, revealed: false } })
          self.playSound('click')
          setTimeout(function () {
            self.revealCards.forEach(function (c, i) {
              setTimeout(function () { self.flipCard(i) }, 380 + i * 220)
            })
            setTimeout(function () {
              self.lastGains = gains
              self.resultModal = true
              self.pulling = false
              self.saveInventory()
            }, 380 + n * 220 + 420)
          }, 60)
        })
        .catch(function () {
          self.pulling = false
          self.toast('网络异常，抽卡失败', 'bad')
        })
    },
    flipCard(i) {
      const c = this.revealCards[i]
      if (!c || c.revealed) return
      c.revealed = true
      if (c.item.q === 'red') {
        this.playSound('legend')
        this.legendItem = c.item
        this.legendOverlay = true
        this.shake = true
        const self = this
        setTimeout(function () {
          self.legendOverlay = false
          self.shake = false
        }, 2300)
      } else if (c.item.q === 'pink') {
        this.playSound('epic')
      } else {
        this.playSound('flip')
      }
    },
    skipAllReveal() {
      if (!this.pulling) return
      const self = this
      this.revealCards.forEach(function (c, i) {
        self.flipCard(i)
      })
    },
    openMilestone(m) {
      if (this.msClaimed(m.n) || this.poolPullCount < m.n) return
      this.milestoneTarget = m
      this.milestoneModal = true
      this.playSound('click')
    },
    claimMilestone(choice) {
      const m = this.milestoneTarget
      if (!m) return
      if (choice === 'frags') {
        this.fragments += m.frags
        this.playSound('coin')
        this.toast('获得碎片 × ' + m.frags, 'good')
      } else {
        const item = this.pickItem(m.q)
        this.$set(this.bag, item.id, (this.bag[item.id] || 0) + 1)
        this.playSound('epic')
        this.toast('恭喜获得「' + item.name + '」', 'good')
      }
      const poolKey = this.currentPoolKey
      const arr = this.poolClaimed[poolKey] || []
      if (arr.indexOf(m.n) < 0) arr.push(m.n)
      this.$set(this.poolClaimed, poolKey, arr)
      this.milestoneModal = false
      this.saveInventory()
    },
    canClaim(m) {
      return this.poolPullCount >= m.n && !this.msClaimed(m.n)
    },
    msClaimed(n) {
      const arr = this.poolClaimed[this.currentPoolKey] || []
      return arr.indexOf(n) >= 0
    },
    msPos(n) {
      const map = { 10: '4%', 30: '18%', 60: '38%', 100: '62%', 140: '80%', 200: '94%' }
      return map[n] || '50%'
    },
    exchangeItem(item) {
      if (!item) return
      const cost = this.fragCostOf(item)
      if (this.fragments < cost) {
        this.playSound('click')
        this.toast('碎片不足，还差 ' + (cost - this.fragments) + ' 个', 'bad')
        return
      }
      this.fragments -= cost
      this.$set(this.bag, item.id, (this.bag[item.id] || 0) + 1)
      this.playSound('epic')
      this.toast('兑换成功，获得「' + item.name + '」', 'good')
      this.saveInventory()
    },
    sellItem(item, mode) {
      if (!this.bag[item.id]) return
      const remain = this.bag[item.id] - 1
      if (remain <= 0) {
        this.$delete(this.bag, item.id)
      } else {
        this.$set(this.bag, item.id, remain)
      }
      const price = this.priceOf(item)
      let gain = price
      if (mode === 'direct') {
        gain = price
      } else if (Math.random() < 0.5) {
        gain = price * 2
      } else {
        gain = Math.floor(price / 2)
      }
      const self = this
      this.$axios.post(this.$httpUrl + '/user/updateCoin', { no: this.curNo, delta: gain })
        .then(function (r) { return r.data })
        .then(function (res) {
          if (res.code === 200) {
            self.coins = res.data.coin
            self.syncCoinToSession()
            self.saveInventory()
            self.playSound('coin')
            if (mode === 'direct') {
              self.toast('出售「' + item.name + '」，获得 ' + gain + ' 星裙币', 'good')
            } else if (gain > price) {
              self.toast('好运爆棚，获得双倍星裙币！+' + gain, 'good')
            } else {
              self.toast('运气欠佳，获得 ' + gain + ' 星裙币', 'bad')
            }
          } else {
            self.toast(res.msg || '出售失败', 'bad')
          }
        })
        .catch(function () {
          self.toast('网络异常，出售失败', 'bad')
        })
    },
    goPool() {
      this.view = 'pool'
      if (!this.selectedItem) this.selectedItem = POOL[0]
    },
    goBag() {
      this.view = 'bag'
    },
    selectItem(item) {
      this.selectedItem = item
      this.playSound('click')
    },
    qName(k) {
      return (QUALITIES[k] || {}).name || k || '未知'
    },
    qColor(k) {
      return (QUALITIES[k] || {}).color || '#909399'
    },
    priceOf(it) {
      if (!it) return 0
      if (it.price != null) return it.price
      const q = it.q || it.key
      return (QUALITIES[q] || {}).price != null ? QUALITIES[q].price : 0
    },
    fragCostOf(it) {
      if (!it) return 0
      if (it.fragCost != null) return it.fragCost
      const q = it.q || it.key
      return (QUALITIES[q] || {}).fragCost != null ? QUALITIES[q].fragCost : 0
    },
    fragAmountOf(it) {
      if (!it || it.amount == null) return 0
      return it.amount
    },
    probText(k) {
      return (QUALITIES[k] || {}).probText || '-'
    },
    poolOf(q) {
      return POOL.filter(function (it) { return it.q === q })
    },
    itemEmoji(it) {
      if (!it) return ''
      if (it.type === '货币' || it.id === 'u_coin50') return '🪙'
      if (it.type === '碎片' || it.id === 'u_frag50' || it.id === 'u_frag100') return '🧩'
      return ''
    },
    // 从后台「奖池管理」加载奖池列表；失败则沿用内置兜底奖池
    loadPools() {
      const self = this
      this.$axios.get(this.$httpUrl + '/treasurePool/list')
        .then(function (r) { return r.data })
        .then(function (res) {
          let pools = []
          if (res.code === 200 && Array.isArray(res.data)) {
            pools = res.data.map(function (p) {
              return {
                poolKey: p.poolKey,
                name: p.name,
                icon: p.icon || '🎁',
                themeColor: p.themeColor || '#F0619C',
                themeDeep: p.themeDeep || '#E0539C',
                btnColor: p.btnColor || p.themeColor || '#F0619C',
                btnDeep: p.btnDeep || p.themeDeep || '#E0539C',
                bgColor: p.bgColor || p.themeColor || '#F0619C',
                bgDeep: p.bgDeep || p.themeDeep || '#E0539C',
                textColor: p.textColor || p.themeDeep || '#E0539C',
                cardColor: p.cardColor || p.themeDeep || '#FF5FA8'
              }
            })
          }
          if (!pools.length) pools = DEFAULT_POOLS.map(function (p) { return Object.assign({}, p) })
          self.pools = pools
          const first = pools[0]
          self.switchPool(first ? first.poolKey : 'star_skirt')
        })
        .catch(function () {
          self.pools = DEFAULT_POOLS.map(function (p) { return Object.assign({}, p) })
          self.switchPool(DEFAULT_POOLS[0].poolKey)
        })
    },
    // 切换到指定奖池：更新当前奖池与主题，并重新加载该奖池道具
    switchPool(poolKey) {
      const target = this.pools.find(function (p) { return p.poolKey === poolKey }) ||
        DEFAULT_POOLS.find(function (p) { return p.poolKey === poolKey })
      if (!target) return
      this.currentPool = target
      this.loadPool(poolKey)
    },
    // 从后台「宝藏管理」加载当前奖池道具；失败则沿用内置奖池
    loadPool(poolKey) {
      const self = this
      const key = poolKey || 'star_skirt'
      this.$axios.get(this.$httpUrl + '/treasure/list', { params: { poolKey: key } })
        .then(function (r) { return r.data })
        .then(function (res) {
          if (res.code === 200 && Array.isArray(res.data)) {
            const list = res.data.map(function (it) {
              return {
                id: it.itemId,
                q: it.q,
                name: it.name,
                type: it.type,
                amount: it.amount,
                price: it.price != null ? it.price : null,
                fragCost: it.fragCost != null ? it.fragCost : null,
                img: self.resolveImg(it),
                desc: it.remark
              }
            })
            POOL = list
            ITEM_MAP = {}
            list.forEach(function (it) { ITEM_MAP[it.id] = it })
            self.$set(self.poolItems, key, list)
            if (self.selectedItem) {
              self.selectedItem = POOL[0] || null
            }
          }
        })
        .catch(function () { /* 接口不可用时沿用内置奖池 */ })
    },
    // 图片解析：完整URL直接使用；本地文件名匹配打包立绘；否则按道具标识匹配同款立绘
    resolveImg(it) {
      if (!it) return null
      const img = it.img
      if (!img) return null
      if (/^https?:/i.test(img)) return img
      const key = String(img).replace(/\.[a-z0-9]+$/i, '').toLowerCase()
      if (LOCAL_IMGS[key]) return LOCAL_IMGS[key]
      const byId = LOCAL_IMGS[String(it.itemId || '').toLowerCase()]
      return byId || null
    },
    sparkStyle(n) {
      const pos = [[22, 26], [78, 20], [50, 12], [16, 66], [84, 60], [58, 78]]
      const p = pos[(n - 1) % pos.length]
      return {
        left: p[0] + '%',
        top: p[1] + '%',
        animationDelay: (n * 0.14) + 's'
      }
    },
    playSound(type) {
      if (this.muted) return
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext
        if (!Ctx) return
        const ctx = this._audioCtx || (this._audioCtx = new Ctx())
        if (ctx.state === 'suspended') ctx.resume()
        const t = ctx.currentTime
        const notes = {
          click: [[880, 0.06, 'square', 0.10]],
          flip: [[540, 0.07, 'triangle', 0.16]],
          epic: [[660, 0.09, 'triangle', 0.18], [990, 0.14, 'triangle', 0.16]],
          legend: [[523, 0.10, 'triangle', 0.20], [659, 0.10, 'triangle', 0.18], [784, 0.12, 'triangle', 0.20], [1047, 0.35, 'triangle', 0.22]],
          coin: [[1320, 0.08, 'sine', 0.14], [1760, 0.14, 'sine', 0.12]]
        }
        const seq = notes[type] || notes.click
        seq.forEach(function (n, i) {
          const osc = ctx.createOscillator()
          const gain = ctx.createGain()
          const st = t + i * 0.06
          osc.type = n[2]
          osc.frequency.value = n[0]
          gain.gain.setValueAtTime(0.0001, st)
          gain.gain.exponentialRampToValueAtTime(n[3], st + 0.015)
          gain.gain.exponentialRampToValueAtTime(0.0001, st + n[1])
          osc.connect(gain)
          gain.connect(ctx.destination)
          osc.start(st)
          osc.stop(st + n[1] + 0.02)
        })
      } catch (e) { /* 忽略 */ }
    },
    initDecor() {
      const el = this.$refs.decor
      if (!el) return
      const frag = document.createDocumentFragment()
      const petals = ['#ffc1dd', '#ff9dc6', '#ffd6e7', '#ffb3d1', '#ff8fc7', '#ffe9f2']
      for (let i = 0; i < 24; i++) {
        const p = document.createElement('i')
        p.className = 'petal'
        const size = 8 + Math.random() * 9
        p.style.width = size + 'px'
        p.style.height = (size * 1.3) + 'px'
        p.style.left = (Math.random() * 100) + '%'
        p.style.animationDuration = (6 + Math.random() * 7).toFixed(2) + 's'
        p.style.animationDelay = (Math.random() * 9).toFixed(2) + 's'
        p.style.opacity = (0.45 + Math.random() * 0.45).toFixed(2)
        p.style.setProperty('--sway', ((Math.random() * 90) - 45).toFixed(0) + 'px')
        p.style.background = petals[i % petals.length]
        frag.appendChild(p)
      }
      for (let i = 0; i < 20; i++) {
        const s = document.createElement('i')
        s.className = 'spark'
        const size = 5 + Math.random() * 8
        s.style.width = size + 'px'
        s.style.height = size + 'px'
        s.style.left = (Math.random() * 100) + '%'
        s.style.top = (Math.random() * 100) + '%'
        s.style.animationDelay = (Math.random() * 4).toFixed(2) + 's'
        frag.appendChild(s)
      }
      el.appendChild(frag)
    }
  },
  mounted() {
    this.loadPools()
    try {
      this.muted = localStorage.getItem('pc-muted') === '1'
    } catch (e) { /* 忽略 */ }
    try {
      const cu = JSON.parse(sessionStorage.getItem('CurUser') || '{}')
      this.curNo = cu.no || ''
      this.coins = cu.coin || 0
    } catch (e) { /* ignore */ }
    this.loggedIn = !!this.curNo
    if (this.loggedIn) {
      this.refreshCoin()
      this.loadInventory()
    }
    bus.$on('music:user-changed', this.onUserChanged)
    this.initDecor()
  },
  beforeDestroy() {
    bus.$off('music:user-changed', this.onUserChanged)
    const el = this.$refs.decor
    if (el) el.innerHTML = ''
  }
}
</script>

<style scoped>

/* ============================================================
   洛丽寻宝 · 星纱洛丽塔（全面翻新 v2）
   ============================================================ */

.pc-root {
  height: 100vh;
  padding: 60px 0 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  color: #7a2f52;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', system-ui, -apple-system, sans-serif;
  background: var(--bg-grad, linear-gradient(180deg, #fff2f7 0%, #ffe7f0 40%, #ffd4e5 78%, #f6c9de 100%));
  overflow-x: hidden;
}

/* ===== 装饰层：花瓣 / 闪光粒子 / 角落挂件 ===== */
.pc-decor {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 3;
  overflow: hidden;
}
.petal {
  position: absolute;
  top: -24px;
  border-radius: 70% 0 70% 70%;
  animation: petal-fall linear infinite;
  filter: drop-shadow(0 2px 3px rgba(255, 143, 199, 0.35));
}
@keyframes petal-fall {
  0% { transform: translate(0, -5vh) rotate(0deg); }
  100% { transform: translate(var(--sway, 40px), 108vh) rotate(340deg); }
}
.spark {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, #fff 20%, rgba(255, 255, 255, 0));
  animation: glint 2.8s ease-in-out infinite;
}
@keyframes glint {
  0%, 100% { opacity: 0.08; transform: scale(0.6); }
  50% { opacity: 0.95; transform: scale(1.25); }
}
.pc-corner {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.pc-corner svg {
  position: absolute;
  filter: drop-shadow(0 2px 4px rgba(255, 143, 199, 0.3));
}
.corner-heart.tl { top: 84px; left: 18px; animation: dangle 3.6s ease-in-out infinite; }
.corner-heart.br { right: 26px; bottom: 120px; animation: dangle 4.2s ease-in-out infinite; }
.corner-bow.tr { top: 16px; right: 96px; animation: dangle 4.8s ease-in-out infinite; }
.corner-bow.bl { bottom: 40px; left: 30px; animation: dangle 4s ease-in-out infinite; }
@keyframes dangle {
  0%, 100% { transform: rotate(-4deg) translateY(0); }
  50% { transform: rotate(5deg) translateY(6px); }
}

/* ===== 顶部栏（悬浮胶囊玻璃条） ===== */
/* ===== 全站左右布局外壳 ===== */
.treasure-layout {
  position: relative;
  z-index: 2;
  display: flex;
  height: calc(100vh - 60px);
  min-height: 0;
}

/* ===== 左侧固定功能区 ===== */
.treasure-side {
  flex: 0 0 15%;
  width: 15%;
  min-width: 210px;
  max-width: 300px;
  box-sizing: border-box;
  padding: 18px 14px 18px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-right: 2px dashed rgba(255, 170, 210, 0.55);
  background:
    radial-gradient(circle at 20% 6%, rgba(255, 214, 233, 0.7), transparent 48%),
    radial-gradient(circle at 92% 94%, rgba(194, 229, 255, 0.55), transparent 48%),
    linear-gradient(180deg, #ffeaf5, #fff5fb);
}

/* 侧栏通用卡片 */
.side-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1.5px solid #ffd9e8;
  border-radius: 18px;
  box-shadow: 0 8px 22px rgba(217, 93, 139, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.95);
  padding: 15px 14px;
}
.side-card-title {
  font-size: 14px;
  font-weight: 800;
  color: #d44f86;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

/* 品牌卡 */
.side-brand {
  text-align: center;
  padding: 18px 12px 16px;
}
.side-badge {
  display: inline-block;
  padding: 6px 20px;
  border-radius: 30px;
  background: linear-gradient(90deg, #ff8ec6, #a78bfa);
  color: #fff;
  font-size: 13px;
  letter-spacing: 2px;
  font-weight: bold;
  box-shadow: 0 6px 16px rgba(255, 142, 198, 0.4);
}
.side-name {
  font-size: 21px;
  font-weight: 800;
  letter-spacing: 2px;
  margin: 12px 0 6px;
  line-height: 1.45;
  background: linear-gradient(120deg, #ff4d8b, #c39aff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.side-slogan {
  margin: 0;
  font-size: 11px;
  color: #c47e9d;
  letter-spacing: 1px;
}

/* 账号卡：未登录提示 */
.side-login {
  font-size: 13px;
  color: #c47e9d;
  text-align: center;
  padding: 6px 0;
}

/* 功能菜单 */
.side-menu .menu-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border-radius: 11px;
  font-size: 14px;
  color: #8a4a63;
  cursor: pointer;
  margin-bottom: 5px;
  transition: all 0.2s ease;
}
.side-menu .menu-item i {
  font-size: 16px;
}
.side-menu .menu-item:last-child { margin-bottom: 0; }
.side-menu .menu-item:hover {
  background: #fff0f7;
  color: #e0539c;
}
.side-menu .menu-item.active {
  background: linear-gradient(135deg, #ff9ec3, #f0619c);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(240, 97, 156, 0.32);
}

/* 侧栏底部 */
.side-foot {
  margin-top: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
.side-sound {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  border: 1.5px solid #ffc4dd;
  color: #ff6fa5;
  padding: 6px 14px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 143, 199, 0.2);
  transition: transform 0.15s;
}
.side-sound:hover { transform: translateY(-1px); }
.side-sound.off { opacity: 0.5; }

/* ===== 右侧内容区 ===== */
.treasure-main {
  flex: 1;
  min-width: 0;
  overflow-y: hidden;
  padding: 18px 26px 0;
  box-sizing: border-box;
}

/* ===== 右侧奖池切换栏（竖向容器） ===== */
.pool-switcher {
  flex: 0 0 auto;
  width: 80px;
  box-sizing: border-box;
  padding: 16px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  border-left: 2px dashed rgba(255, 170, 210, 0.55);
  background:
    radial-gradient(circle at 50% 8%, rgba(255, 214, 233, 0.85), transparent 55%),
    linear-gradient(180deg, #ffeaf5, #fff5fb);
  overflow-y: auto;
}
.switcher-title {
  font-size: 12px;
  font-weight: 800;
  color: var(--text-color, #d44f86);
  letter-spacing: 2px;
  //writing-mode: vertical-lr;
}
.switcher-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.switcher-icon {
  width: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}
.switcher-ico {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  background: linear-gradient(135deg, #ffe3f0, #ffc4dd);
  border: 2px solid #fff;
  box-shadow: 0 4px 10px rgba(240, 97, 156, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.switcher-icon:hover .switcher-ico {
  transform: translateY(-2px) scale(1.06);
  box-shadow: 0 6px 14px rgba(240, 97, 156, 0.35);
}
.switcher-icon.active .switcher-ico {
  background: linear-gradient(135deg, var(--theme-color), var(--theme-deep));
  box-shadow: 0 4px 14px var(--theme-glow), 0 0 0 3px rgba(255, 255, 255, 0.85);
}
.switcher-label {
  font-size: 10px;
  color: #a05a7c;
  white-space: nowrap;
}
.switcher-icon.active .switcher-label {
  color: var(--text-color, #e0539c);
  font-weight: 700;
}
.lottery-view,
.bag-view {
 //max-width: 1180px;
  margin: 0 auto;
}
.lottery-view {
  display: flex;
  flex-direction: column;

  min-height: 100%;
}

/* ===== 悬浮固定底部停靠区（上层抽奖按钮 / 下层补给里程碑） ===== */
.lottery-dock {
  position: sticky;
  bottom: 0;
  z-index: 20;
  margin: auto -26px 0;
  padding: 12px 26px 25px;
  //background: linear-gradient(180deg, rgba(255, 240, 247, 0.72), rgba(255, 226, 239, 0.94) 42%, rgba(255, 219, 235, 0.97));
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  //border-top: 2px solid rgba(255, 157, 196, 0.65);
  //box-shadow: 0 -12px 34px rgba(255, 110, 165, 0.25);
}
.pool-view { padding-bottom: 0; }
.bag-view { padding-bottom: 30px; }
.bag-view {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
}

/* 账号信息行（侧栏账号卡内） */
.account-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 2px;
  border-bottom: 1px dashed #ffd9e9;
  font-size: 13px;
}
.account-row:last-child {
  border-bottom: none;
}
.account-label {
  color: #a05a7c;
  white-space: nowrap;
}
.account-value {
  font-weight: 700;
  color: #7a2f52;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.account-value.account-coins {
  color: #ff4d8b;
  text-shadow: 0 0 12px rgba(255, 95, 168, 0.35);
}
.account-value.account-frags {
  color: #9d6bff;
  text-shadow: 0 0 12px rgba(157, 107, 255, 0.35);
}

/* ===== 抽卡舞台 ===== */
.stage {
  position: relative;
  top: 70px;
  min-height: 55vh;
  background:
    radial-gradient(560px 280px at 50% 0%, rgba(255, 255, 255, 0.92), transparent 72%),
    radial-gradient(420px 220px at 88% 10%, rgba(255, 214, 236, 0.6), transparent 65%),
    radial-gradient(420px 240px at 6% 92%, rgba(255, 182, 216, 0.45), transparent 65%),
    rgba(255, 255, 255, 0.6);
  border: 2px solid #ffc4dd;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 16px;
  box-shadow:
    0 16px 38px rgba(255, 143, 199, 0.22),
    inset 0 0 0 1px rgba(255, 255, 255, 0.85),
    inset 0 0 46px rgba(255, 214, 236, 0.28);
}
.stage::before {
  content: '';
  position: absolute;
  inset: 7px;
  border-radius: 20px;
  border: 1.5px dashed rgba(255, 95, 168, 0.3);
  pointer-events: none;
  z-index: 0;
}
.stage > * {
  position: relative;
  z-index: 1;
}
.stage-shake {
  animation: stage-shake 0.5s ease;
}
@keyframes stage-shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-7px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(3px); }
}
.stage-bow {
  position: absolute;
  top: -14px;
  left: 50%;
  margin-left: -11px;
  width: 22px;
  height: 22px;
  background: radial-gradient(circle at 35% 30%, #ffc0d8, #ff4d8b);
  border: 2.5px solid #fff;
  border-radius: 50%;
  z-index: 4;
  box-shadow: 0 3px 10px rgba(255, 95, 168, 0.55);
}
.stage-bow::before,
.stage-bow::after {
  content: '';
  position: absolute;
  top: 1px;
  width: 28px;
  height: 18px;
  background: linear-gradient(135deg, #ff9dc6, #ff6fa5);
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);
}
.stage-bow::before { left: -19px; transform: rotate(-18deg); }
.stage-bow::after { right: -19px; transform: rotate(18deg); }

.stage-idle {
  text-align: center;
  color: #c47e9d;
}
.idle-ring {
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
  border-radius: 50%;
  border: 3px solid rgba(255, 95, 168, 0.28);
  border-top-color: #ff6fa5;
  animation: spin 2.4s linear infinite;
  position: relative;
  box-shadow: 0 0 24px rgba(255, 143, 199, 0.25);
}
.idle-ring::after {
  content: '';
  position: absolute;
  inset: 11px;
  border-radius: 50%;
  border: 2px dashed rgba(255, 143, 199, 0.55);
  animation: spin 6s linear infinite reverse;
}
.idle-ring::before {
  content: '♡';
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #ff6fa5;
  animation: idle-heart 1.6s ease-in-out infinite;
}
@keyframes idle-heart {
  0%, 100% { transform: scale(0.92); opacity: 0.7; }
  50% { transform: scale(1.08); opacity: 1; }
}
.idle-text {
  font-size: 15px;
  line-height: 1.9;
  letter-spacing: 2px;
}

/* ===== 抽卡卡片 ===== */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  justify-content: center;
  gap: 14px;
  width: 100%;
  max-width: 1100px;
}
.cards-grid:not(.is-ten) {
  grid-template-columns: repeat(1, minmax(0, 300px));
}
.card-slot {
  perspective: 1000px;
  animation: pop-in 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes pop-in {
  from { opacity: 0; transform: scale(0.5) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.card {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4.1;
}
.card-inner {
  position: absolute;
  inset: 0;
  transform-style: preserve-3d;
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}
.card.revealed .card-inner {
  transform: rotateY(180deg);
}
.card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: 16px;
  overflow: hidden;
}
.card-back {
  background:
    radial-gradient(circle at 50% 26%, rgba(255, 255, 255, 0.85) 0 13px, transparent 14px),
    radial-gradient(circle at 16px 16px, var(--card-dot, rgba(255, 95, 168, 0.22)) 2px, transparent 2.7px),
    var(--card-bg, linear-gradient(160deg, #ffeef5, #ffd9e8 55%, #ffc7de));
  background-size: auto, 22px 22px, auto;
  border: 2px solid var(--card-border, #ffb3d1);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.5);
}
.back-pattern {
  position: absolute;
  inset: 8px;
  border-radius: 11px;
  border: 1.5px dashed var(--card-dash, rgba(255, 95, 168, 0.5));
  background-image: radial-gradient(circle at 10px 10px, var(--card-pat, rgba(255, 95, 168, 0.2)) 2px, transparent 2.5px);
  background-size: 20px 20px;
}
.back-text {
  color: var(--text-color, #ff4d8b);
  font-weight: 800;
  letter-spacing: 4px;
  font-size: 13px;
  text-shadow: 0 1px 0 #fff, 0 0 14px rgba(255, 143, 199, 0.9);
}
.card-front {
  transform: rotateY(180deg);
  background: linear-gradient(180deg, #fff5f9, #ffe9f2);
  display: flex;
  flex-direction: column;
}
.card-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.card-type {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 3;
  background: rgba(255, 255, 255, 0.88);
  color: #ff4d8b;
  font-size: 10px;
  padding: 2px 9px;
  border-radius: 999px;
  letter-spacing: 1px;
  border: 1px solid #ffc4dd;
  box-shadow: 0 2px 6px rgba(255, 143, 199, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.card-name {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  padding: 18px 8px 10px;
  background: linear-gradient(transparent, rgba(255, 95, 168, 0.92));
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1px 3px rgba(120, 20, 70, 0.55);
}

/* ===== 品质色文字背景（跟随物品品质颜色） ===== */
.q-green .card-name {
  background: linear-gradient(transparent, rgba(127, 220, 156, 0.92));
}
.q-purple .card-name {
  background: linear-gradient(transparent, rgba(195, 154, 255, 0.92));
}
.q-blue .card-name {
  background: linear-gradient(transparent, rgba(127, 201, 255, 0.92));
}
.q-pink .card-name {
  background: linear-gradient(transparent, rgba(255, 127, 185, 0.92));
}
.q-red .card-name {
  background: linear-gradient(transparent, rgba(255, 77, 109, 0.92));
}

/* ===== 品质边框与特效 ===== */
.card-front {
  border: 2px solid transparent;
}
.q-green .card-front {
  border-color: #7fdc9c;
  box-shadow: 0 0 14px rgba(127, 220, 156, 0.45), inset 0 0 16px rgba(127, 220, 156, 0.14);
}
.q-purple .card-front {
  border-color: #c39aff;
  box-shadow: 0 0 16px rgba(195, 154, 255, 0.5), inset 0 0 16px rgba(195, 154, 255, 0.16);
}
.q-blue .card-front {
  border-color: #7fc9ff;
  box-shadow: 0 0 18px rgba(127, 201, 255, 0.55), inset 0 0 16px rgba(127, 201, 255, 0.18);
}
.q-pink .card-front {
  border-color: #ff7fb9;
  box-shadow: 0 0 20px rgba(255, 127, 185, 0.65), inset 0 0 18px rgba(255, 127, 185, 0.2);
}
.q-red .card-front {
  border-color: transparent;
  box-shadow: 0 0 28px rgba(255, 77, 109, 0.75), inset 0 0 22px rgba(255, 77, 109, 0.22);
}
.q-red .card-front::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 5;
  border-radius: 16px;
  padding: 2.5px;
  background: conic-gradient(from 0deg, #ff4d6d, #ffd9a0, #ff7fb9, #ffd6e7, #ff4d6d);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  animation: border-rotate 3s linear infinite;
  pointer-events: none;
}
@keyframes border-rotate {
  to { transform: rotate(360deg); }
}
.q-red.revealed .card-front {
  animation: red-pulse 1.6s ease-in-out infinite;
}
@keyframes red-pulse {
  0%, 100% { box-shadow: 0 0 26px rgba(255, 77, 109, 0.65), inset 0 0 22px rgba(255, 77, 109, 0.2); }
  50% { box-shadow: 0 0 52px rgba(255, 77, 109, 1), inset 0 0 30px rgba(255, 127, 185, 0.35); }
}

.card-shine {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(105deg, transparent 40%, rgba(255, 255, 255, 0.5) 50%, transparent 60%);
  animation: shine-sweep 1.6s ease-in-out 0.3s infinite;
}
@keyframes shine-sweep {
  from { transform: translateX(-110%); }
  to { transform: translateX(110%); }
}

.card-sparks {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
}
.card-sparks i {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 6px currentColor;
  animation: spark 1.4s ease-out infinite;
}
.card-sparks i:nth-child(odd) { background: #ffd9a0; color: #ffd9a0; }
.card-sparks i:nth-child(even) { background: #fff; color: #ffd6e7; }
.card-sparks i:nth-child(1) { --dx: -9px; animation-delay: 0.1s; }
.card-sparks i:nth-child(2) { --dx: 8px; animation-delay: 0.35s; }
.card-sparks i:nth-child(3) { --dx: -4px; animation-delay: 0.6s; }
.card-sparks i:nth-child(4) { --dx: 10px; animation-delay: 0.85s; }
.card-sparks i:nth-child(5) { --dx: -10px; animation-delay: 1.05s; }
.card-sparks i:nth-child(6) { --dx: 5px; animation-delay: 1.25s; }
@keyframes spark {
  0% { opacity: 0; transform: translate(0, 0) scale(0.6); }
  25% { opacity: 1; }
  100% { opacity: 0; transform: translate(var(--dx, 6px), -20px) scale(1.1); }
}

.skip-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 8;
  border: 2px solid #ffc4dd;
  background: rgba(255, 255, 255, 0.88);
  color: #ff4d8b;
  border-radius: 999px;
  padding: 5px 15px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(255, 143, 199, 0.25);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* ===== 抽卡按钮（缎带渐变 + 微光扫过） ===== */
.pull-bar {
  display: flex;
  gap: 125px;
  justify-content: center;
  margin-top: 0;
  flex-wrap: wrap;
}
.btn-pull {
  position: relative;
  overflow: hidden;
  min-width: 210px;
  border: none;
  border-radius: 20px;
  padding: 5px 28px;
  cursor: pointer;
  color: #fff;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  transition: transform 0.15s, box-shadow 0.15s;
}
.btn-pull:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-pull::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -90%;
  width: 55%;
  background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  transition: left 0.5s ease;
  pointer-events: none;
}
.btn-pull:hover:not(:disabled)::after {
  left: 130%;
}
.btn-single {
  background: linear-gradient(135deg, var(--theme-color), var(--theme-deep));
  box-shadow: 0 8px 24px var(--theme-glow), inset 0 1.5px 0 rgba(255, 255, 255, 0.65), inset 0 -2px 6px rgba(0, 0, 0, 0.12);
}
.btn-ten {
  background: linear-gradient(135deg, var(--theme-color), var(--theme-deep) 55%, var(--theme-deep2));
  box-shadow: 0 8px 26px var(--theme-glow), inset 0 1.5px 0 rgba(255, 255, 255, 0.5), inset 0 -2px 6px rgba(0, 0, 0, 0.18);
}
.btn-pull:hover:not(:disabled) {
  transform: translateY(-3px);
}
.btn-pull:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}
.btn-main {
  font-size: 21px;
  letter-spacing: 5px;
  text-indent: 5px;
  text-shadow: 0 2px 3px rgba(180, 40, 100, 0.4);
}
.btn-cost {
  font-size: 12px;
  opacity: 0.92;
  font-weight: 500;
}

/* ===== 里程碑 ===== */
.milestone {
  position: relative;
  margin-top: 12px;
  background: rgba(255, 255, 255, 0.78);
  border: 2px solid #ffc4dd;
  border-radius: 20px;
  padding: 16px 20px 10px;
  box-shadow: 0 12px 30px rgba(255, 143, 199, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.95);
}
.milestone-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.ms-label {
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 14px;
  color: #ff4d8b;
}
.ms-label::before {
  content: '♕';
  margin-right: 6px;
  font-size: 13px;
}
.ms-total {
  font-size: 12px;
  color: #c47e9d;
  background: rgba(255, 214, 236, 0.5);
  padding: 2px 12px;
  border-radius: 999px;
}
.ms-track {
  position: relative;
  height: 54px;
}
.ms-fill {
  position: absolute;
  top: 27px;
  left: 0;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, var(--theme-color), var(--theme-deep), var(--theme-deep2));
  box-shadow: 0 0 12px var(--theme-glow);
  transition: width 0.5s ease;
}
.ms-node {
  position: absolute;
  top: 12px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  width: 56px;
  cursor: pointer;
  z-index: 2;
}
.ms-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
  background: linear-gradient(180deg, #fff4f9, #ffe9f2);
  border: 2px solid #ffc4dd;
  color: #d08aab;
  transition: 0.2s;
  box-shadow: inset 0 1px 0 #fff;
}
.ms-node.ready .ms-dot {
  background: linear-gradient(135deg, #ff9db8, #ff4d8b);
  border-color: #fff;
  color: #fff;
  box-shadow: 0 0 18px rgba(255, 95, 168, 0.95);
  animation: ms-pulse 1.4s ease-in-out infinite;
}
@keyframes ms-pulse {
  0%, 100% { box-shadow: 0 0 10px rgba(255, 95, 168, 0.5); transform: scale(1); }
  50% { box-shadow: 0 0 26px rgba(255, 95, 168, 1); transform: scale(1.12); }
}
.ms-node.done .ms-dot {
  background: linear-gradient(180deg, #e9fbef, #c5f2d6);
  border-color: #7fdc9c;
  color: #2da35f;
}
.ms-node.locked {
  cursor: default;
}
.ms-tip {
  font-size: 11px;
  color: #c47e9d;
  white-space: nowrap;
}
.ms-node.ready .ms-tip {
  color: #ff4d8b;
  font-weight: 700;
}
.ms-node.done .ms-tip {
  color: #2da35f;
}

/* ===== 导航 ===== */
.nav-row {
  display: flex;
  gap: 14px;
  justify-content: center;
  margin-top: 24px;
  flex-wrap: wrap;
}
.nav-btn {
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 16px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
  letter-spacing: 2px;
  transition: transform 0.15s, box-shadow 0.15s;
  box-shadow: 0 6px 20px rgba(255, 127, 185, 0.45), inset 0 1.5px 0 rgba(255, 255, 255, 0.5);
}
.nav-btn::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -90%;
  width: 55%;
  background: linear-gradient(105deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transform: skewX(-20deg);
  transition: left 0.5s ease;
  pointer-events: none;
}
.nav-btn:hover::after {
  left: 130%;
}
.nav-btn:hover {
  transform: translateY(-2px);
}
.nav-exchange {
  background: linear-gradient(135deg, #ff8fc7, #ff4d8b);
}
.nav-bag {
  background: linear-gradient(135deg, #c9a8ff, #9d6bff);
  box-shadow: 0 6px 20px rgba(157, 107, 255, 0.5), inset 0 1.5px 0 rgba(255, 255, 255, 0.4);
}

/* ===== 奖池预览 ===== */
.pool-view {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  height: calc(100vh - 78px);
  min-height: 0;
}
.pool-side {
  flex: 0 0 280px;
  width: 280px;
  min-width: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9), rgba(255, 244, 249, 0.82));
  border: 2px solid #ffc4dd;
  border-radius: 20px;
  padding: 16px;
  position: sticky;
  top: 8px;
  height: calc(100vh - 118px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 30px rgba(255, 143, 199, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.95);
}
.pool-side-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1.5px dashed rgba(255, 95, 168, 0.3);
}
.pool-side-title {
  margin: 0;
  font-size: 18px;
  letter-spacing: 2px;
  color: var(--text-color, #ff4d8b);
}
.pool-side-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}
.back-btn {
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid #ffc4dd;
  color: #ff4d8b;
  border-radius: 999px;
  padding: 4px 15px;
  cursor: pointer;
  font-size: 12px;
  box-shadow: 0 3px 8px rgba(255, 143, 199, 0.18);
  transition: transform 0.15s;
}
.back-btn:hover { transform: translateY(-1px); }
.pool-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b48aa8;
  font-size: 13px;
  letter-spacing: 1px;
}
.pool-list {
  overflow-y: auto;
  flex: 1;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #ff8ec6 rgba(255, 214, 233, 0.25);
}
.pool-list::-webkit-scrollbar {
  width: 4px;
}
.pool-list::-webkit-scrollbar-track {
  background: rgba(255, 214, 233, 0.25);
  border-radius: 999px;
}
.pool-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #ffb8d6, #ff8ec6);
  border-radius: 999px;
}
.pool-list::-webkit-scrollbar-thumb:hover {
  background: #ff7fb9;
}
.pool-group {
  margin-bottom: 14px;
}
.pool-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 800;
  color: #a05a7c;
  margin-bottom: 8px;
}
.qdot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}
.pool-group-rate {
  margin-left: auto;
  font-size: 11px;
  color: #c47e9d;
  font-weight: 500;
}
.pool-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px;
  border-radius: 14px;
  cursor: pointer;
  border: 2px solid transparent;
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.62);
  transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}
.pool-item:hover {
  background: rgba(255, 255, 255, 0.96);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 143, 199, 0.22);
}
.pool-item.active {
  border-color: #ffb3d1;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 6px 18px rgba(255, 143, 199, 0.3);
}
.pool-item-thumb {
  position: relative;
  flex-shrink: 0;
}
.pool-item-img {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  object-fit: cover;
  display: block;
  box-shadow: 0 3px 8px rgba(160, 60, 110, 0.2);
}
.owned-badge {
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 3;
  background: linear-gradient(135deg, #7de8ab, #3fcb7e);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 999px;
  letter-spacing: 1px;
  box-shadow: 0 2px 6px rgba(63, 203, 126, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.8);
}
.owned-badge.big {
  font-size: 12px;
  padding: 4px 10px;
  top: 8px;
  right: 8px;
}
.pool-item-info {
  min-width: 0;
}
.pool-item-name {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pool-item-type {
  font-size: 11px;
  color: #c47e9d;
  margin: 1px 0 3px;
}
.pool-item-desc {
  font-size: 11px;
  color: #a05a7c;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pool-preview {
  margin-top: 72px;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  display: flex;
}
.preview-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 2px dashed #ffc4dd;
  border-radius: 24px;
  padding: 45px 26px 45px;
  text-align: left;
}
.preview-imgwrap {
  width: min(82%, 440px);
  aspect-ratio: 1;
  //margin-top: 18px;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  //background: rgba(255, 255, 255, 0.6);
}
.preview-imgwrap::after {
  content: '';
  position: absolute;
  inset: 7px;
  border-radius: 12px;
  border: 1.5px dashed rgba(255, 255, 255, 0.85);
  pointer-events: none;
  z-index: 2;
}
.preview-imgwrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-card.q-green .preview-imgwrap {
  border: 2px solid #7fdc9c;
  box-shadow: 0 0 22px rgba(127, 220, 156, 0.45);
}
.preview-card.q-purple .preview-imgwrap {
  border: 2px solid #c39aff;
  box-shadow: 0 0 24px rgba(195, 154, 255, 0.55);
}
.preview-card.q-blue .preview-imgwrap {
  border: 2px solid #7fc9ff;
  box-shadow: 0 0 26px rgba(127, 201, 255, 0.6);
}
.preview-card.q-pink .preview-imgwrap {
  border: 2px solid #ff7fb9;
  box-shadow: 0 0 30px rgba(255, 127, 185, 0.65);
}
.preview-card.q-red .preview-imgwrap {
  border: 2px solid #ff4d6d;
  box-shadow: 0 0 38px rgba(255, 77, 109, 0.75);
  animation: red-pulse 1.8s ease-in-out infinite;
}
.preview-info {
  position: absolute;
  width: 55%;
  min-width: 0;
  bottom: 30px;
  margin-top: auto;
  padding: 0 20px 0;
  text-align: left;
}
.preview-q {
  font-weight: 800;
  letter-spacing: 4px;
  font-size: 14px;
}
.preview-name {
  font-size: 32px;
  font-weight: 800;
  margin: 6px 0 2px;
  color: #7a2f52;
}
.preview-type {
  color: #c47e9d;
  font-size: 13px;
}
.preview-desc {
  margin: 14px 0;
  color: #9c5b7a;
  line-height: 1.8;
  font-size: 16px;
}
.preview-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.meta-chip {
  background: rgba(255, 255, 255, 0.9);
  border: 1.5px solid #ffd3e6;
  padding: 6px 13px;
  border-radius: 999px;
  font-size: 12px;
  color: #a05a7c;
  box-shadow: 0 2px 6px rgba(255, 143, 199, 0.12);
}
.coin-text {
  color: #ff4d8b;
}
.frag-text {
  color: #9d6bff;
}
.preview-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.preview-frags {
  font-size: 13px;
  color: #a05a7c;
}
.preview-frags b {
  font-size: 16px;
}
.preview-exchange {
  border: none;
  border-radius: 14px;
  padding: 11px 32px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #c9a8ff, #9d6bff);
  box-shadow: 0 6px 18px rgba(157, 107, 255, 0.55), inset 0 1.5px 0 rgba(255, 255, 255, 0.4);
  transition: transform 0.15s;
}
.preview-exchange:hover:not(:disabled) { transform: translateY(-2px); }
.preview-exchange:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.pool-preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: #c47e9d;
  font-size: 14px;
  letter-spacing: 1px;
}

/* ===== 背包 ===== */
.bag-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}
.bag-head h2 {
  margin: 0;
  font-size: 21px;
  letter-spacing: 2px;
  color: #ff4d8b;
}
.bag-head h2::before {
  content: '✧';
  margin-right: 8px;
  color: #ff9db8;
}
.bag-head-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.frag-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.88);
  border: 2px solid #e3d2ff;
  padding: 5px 14px;
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(157, 107, 255, 0.2), inset 0 1px 0 #fff;
}
.frag-box.mini {
  padding: 3px 10px;
  gap: 6px;
}
.frag-ico {
  width: 10px;
  height: 10px;
  background: linear-gradient(135deg, #d9b8ff, #9d6bff);
  transform: rotate(45deg);
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(157, 107, 255, 0.9);
}
.frag-num {
  font-weight: 800;
  font-size: 18px;
  color: #9d6bff;
  font-variant-numeric: tabular-nums;
}
.frag-box.mini .frag-num {
  font-size: 14px;
}
.frag-label {
  font-size: 12px;
  color: #b99ae0;
}
.frag-shop-btn {
  border: none;
  border-radius: 999px;
  padding: 9px 20px;
  background: linear-gradient(135deg, #c9a8ff, #9d6bff);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 5px 16px rgba(157, 107, 255, 0.45), inset 0 1.5px 0 rgba(255, 255, 255, 0.4);
  transition: transform 0.15s;
}
.frag-shop-btn:hover { transform: translateY(-2px); }
.bag-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 16px;
}
.bag-card {
  border-radius: 18px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(255, 247, 251, 0.85));
  border: 2px solid #ffd3e6;
  box-shadow: 0 8px 22px rgba(255, 143, 199, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.95);
  transition: transform 0.18s, box-shadow 0.18s;
}
.bag-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(255, 143, 199, 0.26);
}
.bag-card.q-red {
  border-color: rgba(255, 77, 109, 0.6);
  box-shadow: 0 0 22px rgba(255, 77, 109, 0.28);
}
.bag-card.q-pink {
  border-color: rgba(255, 127, 185, 0.55);
}
.bag-card.q-blue {
  border-color: rgba(127, 201, 255, 0.5);
}
.bag-card.q-purple {
  border-color: rgba(195, 154, 255, 0.45);
}
.bag-card.q-green {
  border-color: rgba(127, 220, 156, 0.45);
}
.bag-card-top {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
}
.bag-card-top::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 55%, rgba(255, 143, 199, 0.14));
  pointer-events: none;
}
.bag-card-top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bag-count {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 2;
  background: rgba(255, 77, 139, 0.88);
  color: #fff;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 2px 6px rgba(255, 77, 139, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.bag-card-info {
  padding: 11px 13px 5px;
}
.bag-card-name {
  font-weight: 700;
  font-size: 14px;
  color: #7a2f52;
}
.bag-card-price {
  font-size: 12px;
  color: #ff4d8b;
  margin-top: 3px;
}
.bag-card-frags {
  font-size: 12px;
  color: #9d6bff;
  margin-top: 3px;
}
.bag-card-actions {
  display: flex;
  gap: 8px;
  padding: 8px 13px 13px;
}
.sell-btn {
  flex: 1;
  border: none;
  border-radius: 11px;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s;
}
.sell-btn:hover {
  transform: translateY(-1px);
}
.sell-direct {
  background: rgba(127, 201, 255, 0.18);
  color: #3a9fe0;
  border: 1.5px solid rgba(127, 201, 255, 0.55);
}
.sell-gamble {
  background: linear-gradient(135deg, #ffc1dd, #ff7fb9);
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 127, 185, 0.4);
}
.bag-empty {
  text-align: center;
  padding: 80px 0;
  color: #c47e9d;
}
.bag-empty-main {
  font-size: 19px;
  font-weight: 800;
  color: #a05a7c;
  margin: 0;
}
.bag-empty-main::before {
  content: '♡';
  display: block;
  font-size: 34px;
  color: #ff9db8;
  margin-bottom: 8px;
  animation: idle-heart 1.6s ease-in-out infinite;
}
.bag-empty-sub {
  margin: 8px 0 22px;
  font-size: 13px;
}

/* ===== 弹窗（玫瑰玻璃） ===== */
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(120, 30, 75, 0.38);
  backdrop-filter: blur(9px);
  -webkit-backdrop-filter: blur(9px);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
}
.modal-box {
  position: relative;
  width: min(460px, 100%);
  background: linear-gradient(180deg, #fffdfe, #ffeef5);
  border: 2px solid #ffc4dd;
  border-radius: 24px;
  padding: 26px 26px 22px;
  box-shadow: 0 28px 70px rgba(120, 20, 70, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.98), inset 0 0 0 6px rgba(255, 214, 236, 0.35);
  max-height: 82vh;
  overflow-y: auto;
}
.modal-title {
  margin: 0 0 6px;
  text-align: center;
  font-size: 21px;
  letter-spacing: 3px;
  background: linear-gradient(120deg, #ff4d8b, #ff9db8, #c39aff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.modal-title::before,
.modal-title::after {
  content: '❀';
  font-size: 14px;
  margin: 0 8px;
  color: #ff9db8;
}
.modal-ok {
  display: block;
  width: 100%;
  margin-top: 20px;
  border: none;
  border-radius: 15px;
  padding: 13px;
  background: linear-gradient(135deg, #ff8fc7, #ff4d8b);
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  cursor: pointer;
  letter-spacing: 4px;
  box-shadow: 0 6px 18px rgba(255, 77, 139, 0.45), inset 0 1.5px 0 rgba(255, 255, 255, 0.5);
  transition: transform 0.15s;
}
.modal-ok:hover { transform: translateY(-2px); }
.modal-ok.ghost {
  background: rgba(255, 255, 255, 0.85);
  color: #c47e9d;
  box-shadow: inset 0 0 0 1.5px #ffd3e6;
}
.modal-enter-active,
.modal-leave-active {
  transition: 0.25s ease;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-enter .modal-box,
.modal-leave-to .modal-box {
  transform: scale(0.92) translateY(10px);
}
.modal-box {
  transition: transform 0.25s ease;
}

/* 结果弹窗 */
.result-list {
  max-height: 44vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 14px;
}
.result-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 14px;
  padding: 9px;
  border: 1.5px solid #ffd3e6;
  box-shadow: 0 2px 8px rgba(255, 143, 199, 0.12);
}
.result-row img {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 3px 8px rgba(160, 60, 110, 0.18);
}
.result-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.result-name {
  font-size: 14px;
  font-weight: 700;
  color: #7a2f52;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-q {
  font-size: 11px;
  font-weight: 600;
}
.result-count {
  margin-left: auto;
  font-weight: 800;
  color: #ff4d8b;
  background: rgba(255, 214, 236, 0.55);
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 13px;
}
.result-row.q-red {
  border-color: rgba(255, 77, 109, 0.6);
  box-shadow: 0 0 16px rgba(255, 77, 109, 0.28);
}
.result-row.q-pink {
  border-color: rgba(255, 127, 185, 0.5);
}
.result-row.q-blue {
  border-color: rgba(127, 201, 255, 0.45);
}
.result-row.q-purple {
  border-color: rgba(195, 154, 255, 0.4);
}
.result-row.q-green {
  border-color: rgba(127, 220, 156, 0.4);
}

/* 里程碑弹窗 */
.ms-modal-sub {
  text-align: center;
  color: #a05a7c;
  font-size: 13px;
  margin: 8px 0 0;
}
.ms-choices {
  display: flex;
  gap: 12px;
  margin-top: 18px;
}
.ms-choice {
  flex: 1;
  border: 2px solid #ffd3e6;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 18px 10px;
  cursor: pointer;
  color: #7a2f52;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: 0.18s;
  box-shadow: 0 4px 12px rgba(255, 143, 199, 0.12);
}
.ms-choice:hover {
  border-color: rgba(255, 95, 168, 0.6);
  background: rgba(255, 255, 255, 0.98);
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(255, 143, 199, 0.28);
}
.gem {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  transform: rotate(45deg);
  flex-shrink: 0;
}
.frag-gem {
  background: linear-gradient(135deg, #d9b8ff, #9d6bff);
  box-shadow: 0 0 14px rgba(157, 107, 255, 0.95);
}
.ms-choice-main {
  font-weight: 800;
  font-size: 14px;
}
.ms-choice-sub {
  font-size: 11px;
  color: #c47e9d;
  text-align: center;
  line-height: 1.5;
}

/* 碎片商城弹窗 */
.shop-sub {
  text-align: center;
  color: #a05a7c;
  font-size: 13px;
  margin: 8px 0 0;
}
.frag-num-inline {
  color: #9d6bff;
}
.shop-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 55vh;
  overflow-y: auto;
  padding: 2px 4px 2px 2px;
}
.shop-item-img,
.shop-item-ico {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}
.shop-item-ico {
  background: #fff0f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #d06a9c;
  box-shadow: inset 0 0 0 1.5px #ffd3e6;
}
.shop-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 14px;
  padding: 10px 14px;
  border: 1.5px solid #ffd3e6;
  box-shadow: 0 2px 8px rgba(255, 143, 199, 0.12);
  transition: transform 0.15s, box-shadow 0.15s;
}
.shop-row:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 143, 199, 0.22);
}
.shop-q-name {
  font-weight: 700;
  font-size: 14px;
}
.shop-cost {
  margin-left: auto;
  color: #9d6bff;
  font-weight: 700;
  font-size: 13px;
}
.shop-btn {
  border: none;
  border-radius: 10px;
  padding: 8px 20px;
  background: linear-gradient(135deg, #c9a8ff, #9d6bff);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(157, 107, 255, 0.4);
  transition: transform 0.15s;
}
.shop-btn:hover:not(:disabled) { transform: translateY(-2px); }
.shop-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ===== 传说降临 ===== */
.legend-overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: radial-gradient(circle, rgba(255, 77, 109, 0.35), rgba(255, 240, 246, 0.95) 78%);
}
.legend-rays {
  position: absolute;
  inset: -40%;
  background: conic-gradient(
    from 0deg,
    rgba(255, 143, 199, 0.45),
    transparent 12%,
    rgba(255, 217, 160, 0.45) 30%,
    transparent 42%,
    rgba(255, 143, 199, 0.45) 60%,
    transparent 72%,
    rgba(255, 255, 255, 0.6) 88%,
    rgba(255, 143, 199, 0.45)
  );
  animation: spin 6s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.legend-core {
  position: relative;
  text-align: center;
  animation: legend-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.legend-q {
  font-size: 46px;
  font-weight: 900;
  letter-spacing: 12px;
  text-indent: 12px;
  background: linear-gradient(120deg, #fff, #ff9db8, #ff4d8b, #fff);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: shine 1.6s linear infinite;
  filter: drop-shadow(0 4px 16px rgba(255, 77, 139, 0.55));
}
@keyframes shine {
  to { background-position: 200% 0; }
}
.legend-name {
  font-size: 26px;
  font-weight: 800;
  margin-top: 10px;
  color: #ff4d8b;
  text-shadow: 0 0 22px rgba(255, 127, 185, 0.95);
}
.legend-sub {
  color: #ff8fc7;
  letter-spacing: 5px;
  margin-top: 8px;
  font-size: 12px;
}
@keyframes legend-rise {
  from { opacity: 0; transform: scale(0.6); }
  to { opacity: 1; transform: scale(1); }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ===== 提示 ===== */
.toast-wrap {
  position: fixed;
  top: 78px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 90;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  pointer-events: none;
  width: max-content;
  max-width: 92vw;
}
.toast {
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #ffc4dd;
  color: #d6336c;
  padding: 10px 22px;
  border-radius: 999px;
  font-size: 13px;
  box-shadow: 0 10px 28px rgba(255, 95, 168, 0.35);
  text-align: center;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.toast.good {
  border-color: #7fdc9c;
  color: #1f9d57;
}
.toast.bad {
  border-color: #ff7fb9;
  color: #e0438f;
}
.toast-enter-active,
.toast-leave-active {
  transition: 0.3s;
}
.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

/* ===== 响应式 ===== */
@media (max-width: 900px) {
  .treasure-layout {
    flex-direction: column;
    height: auto;
  }
  .treasure-side {
    flex: none;
    width: 100%;
    min-width: 0;
    max-width: none;
    border-right: none;
    border-bottom: 2px dashed rgba(255, 170, 210, 0.55);
    overflow-y: visible;
  }
  .treasure-main {
    overflow-y: visible;
  }
  .pool-switcher {
    flex-direction: row;
    width: 100%;
    padding: 10px 12px;
    border-left: none;
    border-top: 2px dashed rgba(255, 170, 210, 0.55);
    overflow-y: visible;
  }
  .switcher-title {
    writing-mode: horizontal-tb;
  }
  .switcher-icons {
    flex-direction: row;
    gap: 18px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .pc-root {
    height: auto;
    overflow: visible;
  }
  .pool-view {
    flex-direction: column;
    height: auto;
    min-height: 0;
  }
  .bag-view {
    height: auto;
    overflow-y: visible;
  }
  .pool-side {
    flex: none;
    width: 100%;
    position: static;
    max-height: 42vh;
  }
  .pool-preview {
    width: 100%;
  }
  .preview-card {
    flex-direction: column;
    text-align: left;
    height: auto;
    padding: 26px;
  }
  .preview-imgwrap {
    width: min(70%, 320px);
  }
  .preview-meta,
  .preview-actions {
    justify-content: flex-start;
  }
}
@media (max-width: 520px) {
  .pc-root {
    padding: 60px 0 0;
  }
  .treasure-main {
    padding: 12px 10px 0;
  }
  .lottery-dock {
    margin-left: -10px;
    margin-right: -10px;
    padding: 10px 10px 12px;
  }
  .btn-pull { min-width: 150px; padding: 12px 18px; }
  .milestone { margin-top: 10px; padding: 12px 12px 8px; }
  .stage {
    min-height: 300px;
    padding: 20px 10px;
  }
  .cards-grid.is-ten {
    gap: 6px;
  }
  .cards-grid:not(.is-ten) {
    grid-template-columns: repeat(1, minmax(0, 240px));
  }
  .card-name {
    font-size: 11px;
    padding: 14px 4px 8px;
  }
  .card-type {
    font-size: 9px;
    top: 5px;
    left: 5px;
  }
  .btn-pull {
    min-width: 150px;
    flex: 1;
  }
  .ms-tip {
    font-size: 10px;
  }
  .nav-row {
    gap: 10px;
  }
  .nav-btn {
    padding: 11px 18px;
    font-size: 14px;
  }
  .bag-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .bag-head-right {
    width: 100%;
    justify-content: flex-start;
  }
  .legend-q {
    font-size: 34px;
    letter-spacing: 8px;
    text-indent: 8px;
  }
  .legend-name {
    font-size: 20px;
  }
  .modal-box {
    padding: 22px 18px 18px;
  }
}

.pc-coin-login { color: #ff6fa5; font-size: 14px; }
/* 无立绘特殊物品占位（碎片包/星裙币包） */
.card-img-icon, .pool-item-icon, .preview-icon, .bag-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f6efff 0%, #e4ccfc 100%);
  font-size: 48px;
  color: #8e44ad;
  text-align: center;
}
.pool-item-icon { font-size: 32px; }
.preview-icon {
  width: 100%;
  height: 100%;
  min-height: 220px;
  font-size: 96px;
}
.bag-card-icon { font-size: 40px; }

</style>
